import React, {Component} from "react";
import ReactTagInput from "@pathofdev/react-tag-input";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {DialogActions} from "@material-ui/core";
import {Button} from "react-bootstrap";
import TagSuggestionInput from "./TagSuggestionInput";

export default class EditSkillModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            skillNames: (props.skills || []).map(s => s.name),
            procedureNames: (props.procedures || []).map(p => p.name)
        };
    }

    updateSkills() {
        const skills = this.state.skillNames.map(name => ({name}));
        const procedures = this.state.procedureNames.map(name => ({name}));

        const staffDTO = {
            id: this.props.staffId,
            skills: skills,
            procedures: procedures
        };

        RemotingService.postRemoteCall('api/staff/update', staffDTO, () => {
            this.props.close();
            this.props.onSkillsUpdated(skills, procedures);
        });
    }

    render() {
        return (
            <div className="SkillsModal">
                <div className="d-flex align-items-center mb-3">
                    <div className="font-weight-bold text-nowrap">Add Skills</div>
                    <TagSuggestionInput className="ml-3 w-100"
                                        suggestionUrl="api/skill/suggestions"
                                        selected={this.state.skillNames}
                                        onAdd={name => this.setState({skillNames: [...this.state.skillNames, name]})}/>
                </div>
                <div className="mb-3 react-tag-input-disable-manual-entry">
                    <ReactTagInput
                        tags={this.state.skillNames}
                        placeholder=" "
                        onChange={skillNames => this.setState({skillNames})}
                    />
                </div>
                <div className="d-flex align-items-center mb-3">
                    <div className="font-weight-bold text-nowrap">Add Procedures</div>
                    <TagSuggestionInput className="ml-3 w-100"
                                        suggestionUrl="api/skill/procedure/suggestions"
                                        selected={this.state.procedureNames}
                                        onAdd={name => this.setState({procedureNames: [...this.state.procedureNames, name]})}/>
                </div>
                <div className="mb-2 react-tag-input-disable-manual-entry">
                    <ReactTagInput
                        tags={this.state.procedureNames}
                        placeholder=" "
                        onChange={procedureNames => this.setState({procedureNames})}
                    />
                </div>
                <DialogActions>
                    <Button variant="success" onClick={() => this.updateSkills()}>Update</Button>
                </DialogActions>
            </div>
        )
    }

}
